// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3xphk","insightsList":"newBusinessInsightsMenu_insightsList__4WIFg","active":"newBusinessInsightsMenu_active__ZTGfo"};